global.wlAngularDeps = [
  "ngAnimate",
];

global.loadAppDeps = function () {
  require('angular-animate');
  require('../../assets/javascripts/whitelabel/visa/locales');
  require('../../assets/javascripts/whitelabel/visa/controllers/visa-controller');
  require('../../assets/javascripts/whitelabel/visa/components');
}
require('../application');
